<div class="attachment-move-dialog create-company-dialog">
  <div class="flex flex-row  justify-between" style="height: 16px;" >
    <div class="left">
      <h6  class="font-bold text-xl text-[#010B18]" >Create New {{current_template?.type}}</h6>
    </div>
    <div class="right" >
      <button mat-icon-button style="position: relative;top: -6px;" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider class="mt-6 pr-6"    style="margin: 0 -24px;"  ></mat-divider>
  <div class="attachment-move-dialog__content mt-3">
    <p   style="text-transform: capitalize;" class="pr-3 pt-2 pb-2 sm:mb-0 text-sm font-bold">
      General Information
    </p>
    @if (Form1?.length) {
      <div >
        <edit-template-basic-form
          [Form1]="Form1"
          [documentForm]="documentForm">
        </edit-template-basic-form>
      </div>
    }

    <mat-divider class="mt-6 pr-6"    style="margin: 0 -24px;"  ></mat-divider>
    <div>
      <div
          [class]="
            screenWidth >= 480
              ? ' items-start justify-between pl-0 pr-0 w-full h-[65px] pt-3 flex flex-row'
              : 'flex items-start justify-between pl-0 pr-0 w-full h-[65px]  pt-4 flex flex-row'
          "
        >
        <div class="w-[158px]">

        </div>
        <div class="w-[158px]">
          <button
            (click)="saveForm()"
            type="submit"
            style="cursor: pointer;"
            [class]="screenWidth >= 480 ? 'app__btn--primary mt-0' : 'app__btn--primary  m-0 items-center h-[38px]'"
            >
            Save
          </button>
        </div>
      </div>

    </div>

  </div>

</div>